module.exports = __webpack_public_path__ + "dbface78479fb0dfc82a2c1d342fe8ed.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/farbtastic/wheel.png
// module id = 213
// module chunks = 0